import type { FC, PropsWithChildren } from 'react';

import { useTranslation } from 'react-i18next';

import cx from 'classnames';

import type { ITurnStampState } from '../hooks/useTurnStamp';

import styles from './TurnStampOverlay.module.scss';

interface ITurnStampOverlayProps {
  turnStamp: ITurnStampState;
}

export const TurnStampOverlay: FC<ITurnStampOverlayProps> = ({ turnStamp }) => {
  const { t } = useTranslation('matchmaking');
  const { colorVariant, isVisible, prefersReducedMotion, textKey } = turnStamp;

  if (!isVisible) {
    return null;
  }

  return (
    <div
      aria-atomic="true"
      aria-live="polite"
      className={cx(
        styles.turnStamp,
        colorVariant === 'primary'
          ? styles.turnStampPrimary
          : styles.turnStampAccent,
        prefersReducedMotion && styles.turnStampReducedMotion,
      )}
    >
      <div className={styles.turnStampText}>{t(textKey)}</div>
    </div>
  );
};

interface IGameScreenRootProps extends PropsWithChildren {
  turnStamp: ITurnStampState;
}

export const GameScreenRoot: FC<IGameScreenRootProps> = ({
  children,
  turnStamp,
}) => {
  return (
    <div className={styles.gameRoot} data-testid="matchmaking-game-screen-root">
      <TurnStampOverlay turnStamp={turnStamp} />
      {children}
    </div>
  );
};
